import script from "./IndexUser.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexUser.vue?vue&type=script&setup=true&lang=js"

import "./IndexUser.vue?vue&type=style&index=0&id=b51a33d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b51a33d2"]])

export default __exports__